module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; 

var group = function () {
    return groups.find(function (g) {
        return g['value'] === groupBy;
    }) || {};
};

var groupTitles = function () {
    return group()['groupTitle'];
};

var groupTitle = function (level) {
    return groupTitles()[level];
};
var subLength = function (arr) {
    var len = 0;
    arr.forEach(function (row) {
        len+=row.length;
    })
    return len;
}

var toHectare = function (value) {
    if (value == null || value === '') {
        return '';
    }

    return _.round(value / 10000, 0);
};

var numFormat = function (num) {
    if (num && num.length)
        num = num.replace('.',',');
    return num;
}

    ; __append("\n\n<style>\n    .total-row td {\n        font-weight: bold;\n        background: #dcdcdc;\n    }\n</style>\n\n")
    ;  var showDataCells = function (row, tag, index) {
    tag = tag || 'td'; 
    ; __append("\n\n<")
    ; __append(escapeFn( tag ))
    ; __append(" style=\"white-space: nowrap;\">")
    ; __append(escapeFn( index ))
    ; __append("</")
    ; __append(escapeFn( tag ))
    ; __append(">\n<")
    ; __append(escapeFn( tag ))
    ; __append(">")
    ; __append(escapeFn( row.landuser ))
    ; __append("</")
    ; __append(escapeFn( tag ))
    ; __append(">\n<")
    ; __append(escapeFn( tag ))
    ; __append(" ")
    ; __append((row.repeat ? 'style="background:#ed6161"' : ''))
    ; __append(">")
    ; __append(escapeFn( row.cadnum ))
    ; __append("</")
    ; __append(escapeFn( tag ))
    ; __append(">\n<")
    ; __append(escapeFn( tag ))
    ; __append(">")
    ; __append(escapeFn( numFormat(_.round(row.area, 2).toString()) ))
    ; __append("</")
    ; __append(escapeFn( tag ))
    ; __append(">\n<")
    ; __append(escapeFn( tag ))
    ; __append(">")
    ; __append(escapeFn( row.rights ))
    ; __append("</")
    ; __append(escapeFn( tag ))
    ; __append(">\n<")
    ; __append(escapeFn( tag))
    ; __append(" ")
    ; __append((new Date(row.finish_date).getTime() - new Date().getTime() < 1000 * 3600 * 24 * 30 * 2) ? 'style="background:#f5d442"' : '')
    ; __append(">")
    ; __append(escapeFn( row.finish_date ))
    ; __append("</")
    ; __append(escapeFn( tag ))
    ; __append(">\n")
    ;  } 
    ; __append("\n\n\n\n\n<div class=\"wh100\">\n    <div class=\"cell__abs_container\">\n        <div class=\"cell__abs overflow-y__auto\">\n            <table class=\"w100  gl-report__table width-regulator\">\n                <thead>\n                <tr>\n                    ")
    ;  for (var i=0; i<groupTitles().length; i++) {
    ; __append("\n                        <td >")
    ; __append(escapeFn( groupTitle(i) ))
    ; __append("</td>\n                    ")
    ;  } 
    ; __append("\n                    <td>п/п</td>\n                    <td>Наименование СХТП</td>\n                    <td>Кадастровый номер</td>\n                    <td>Площадь, га</td>\n                    <td>Право использования земельного участка</td>\n                    <td>Срок окончания договора аренды, субаренды</td>\n                </tr>\n                </thead>\n                <tbody>\n\n\n                ")
    ;  data.rows.forEach(function (row, index) { 
    ; __append("\n                ")
    ;  if (row.total === 'true') {
    ; __append("\n                <tr class=\"total-row\">\n                ")
    ;  } else {
    ; __append("\n                <tr>\n                ")
    ;  }
    ; __append("\n                    ")
    ; showDataCells(row, 'td', index)
    ; __append("\n                </tr>\n                ")
    ; })
    ; __append("\n                <tr>\n                    <td>-</td>\n                    <td>Итого</td>\n                    <td>-</td>\n                    ")
    ;   
    ; __append("\n                    <td>")
    ; __append(escapeFn( numFormat(_.round(data.total.area, 2).toString()) ))
    ; __append("</td>\n                    <td>-</td>\n                    <td>-</td>\n                </tr>\n\n                </tbody>\n            </table>\n        </div>\n    </div>\n</div>\n")
  }
  return __output.join("");

}